class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById("cart-notification");
    this.teaser = this.querySelector('.cart-notification__teaser');
    this.header = document.querySelector("section-header");
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.notification.addEventListener(
      "keyup",
      (evt) => evt.code === "Escape" && this.close()
    );
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener("click", this.close.bind(this))
    );
  }

  addTaxi() {
    if (this.taxiId) {
      jQuery
        .post("/cart/add.js", {
          items: [
            {
              quantity: 1,
              id: this.taxiId,
            },
          ],
          sections: "cart-notification-product,cart-notification-button,cart-icon-bubble",
          sections_url: window.location.pathname
        })
        .then((response) => {
          const parsedResponse = JSON.parse(response);
          this.renderContents(parsedResponse, true, false, true);
        });
    }
  }

  open() {
    document.querySelector("#snippet-back-to-top__button").classList.remove('visible');
    document.body.classList.add("overflow-hidden");
    this.notification.parentNode.classList.add("open");
    this.notification.classList.add("animate", "active");

    this.notification.addEventListener(
      "transitionend",
      () => {
        this.notification.focus();
        trapFocus(this.notification);
      },
      { once: true }
    );

    document.body.addEventListener("click", this.onBodyClick);
  }

  close() {
    document.querySelector("#snippet-back-to-top__button").classList.add('visible');
    document.body.classList.remove("overflow-hidden");
    this.notification.parentNode.classList.remove("open");
    this.notification.classList.remove("active");

    document.body.removeEventListener("click", this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState, isTrackExperience = false, taxiId, update = false) {
    if (isTrackExperience && taxiId) {
      this.taxiId = taxiId;
      this.teaser.style.display = "block";
      this.teaser.querySelector("button").addEventListener(
        "click",
        this.addTaxi.bind(this)
      );
    } else {
      this.teaser.style.display = "none";
    }

    if(!update) this.productId = parsedState.items[0].id;
    this.getSectionsToRender().forEach((section) => {
      document.getElementById(section.id).innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector
      );
    });

    if (isTrackExperience && parsedState.items.length > 0) {
      const list = this.querySelector(
        "#cart-notification-product .cart-notification-product__list"
      );
      const startIndex = update ? 0 : 1;
      for (let i = startIndex; i < parsedState.items.length; i++) {
        const li = document.createElement("li");
        li.innerText = `+ ${parsedState.items[i].product_title}`;
        list.appendChild(li);
      }
    }

    // this.header?.reveal();
    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: "cart-notification-product",
        selector: `#cart-notification-product-${this.productId}`,
      },
      {
        id: "cart-notification-button",
        selector: "#shopify-section-cart-notification-button",
      },
      {
        id: "cart-icon-bubble",
        section: document.getElementById("cart-icon-bubble").dataset.id,
        selector: "#shopify-section-cart-icon-bubble",
      },
    ];
  }

  getSectionInnerHTML(html, selector = ".shopify-section") {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest("cart-notification")) {
      const disclosure = target.closest("details-disclosure");
      this.activeElement = disclosure
        ? disclosure.querySelector("summary")
        : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define("cart-notification", CartNotification);
